import { ViewModel, View } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { CurrentCredentials } from "src/server/currentCredentials";
import { ServerConnection } from "src/server/serverConnection";
import { ChangePasswordView } from "./changePassword-view"

export class ChangePasswordViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("changePassword-viewModel.changePassword", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View<ViewModel> {
        return new ChangePasswordView();
    }
    public getTypeId(): string {
        return "VM-3267F50E-E509-4A45-B64B-A95428DA1067"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username; } private _username: string;
    public set oldPassword(v: string) { this._oldPassword = v; } public get oldPassword(): string { return this._oldPassword; } private _oldPassword: string;
    public set newPassword(v: string) { this._newPassword = v; } public get newPassword(): string { return this._newPassword; } private _newPassword: string;
    public set newPasswordRepetition(v: string) { this._newPasswordRepetition = v; } public get newPasswordRepetition(): string { return this._newPasswordRepetition; } private _newPasswordRepetition: string;

    async changePassword() {
        try {
            let verificationReuslt = this.verifyInformation();
            if (verificationReuslt.length != 0) {
                this.messageBoxConfirmWarning(verificationReuslt.join("\n"), translate("changePassword-viewModel.changePassword", {}));
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServerWithUsernameAndPassword('Complex/AuthenticationServices/ChangePassword', {
                NewPassword: this.newPassword
            },CurrentCredentials.username,this.oldPassword,[],CurrentCredentials.sessionId)
            if (result.IsSuccessful) {
                CurrentCredentials.password = this.newPassword;
                this.messageBoxConfirmSuccess(translate("changePassword-viewModel.successfullyRegistered", {}), translate("changePassword-viewModel.changePassword", {}));
                return;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    verifyInformation(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.oldPassword)) { result.push(translate("changePassword-viewModel.oldPasswordError", {})); }
        if (stringIsNullOrEmpty(this.newPassword)) { result.push(translate("changePassword-viewModel.newPasswordError", {})); }
        if (stringIsNullOrEmpty(this.newPasswordRepetition)) { result.push(translate("changePassword-viewModel.repeatedPasswordError", {})); }
        if (CurrentCredentials.password != this.oldPassword) { result.push(translate("changePassword-viewModel.oldPasswordWrongError", {})); }
        if (this.newPassword != this.newPasswordRepetition) { result.push(translate("changePassword-viewModel.oldAndRepeatedPasswrodError", {})); }
        return result;
    }
}
